export default {
    language: "English",
    StripeSuccess: {
        loading: "Processing your payment...",
        successMessage: "Your subscription has been successfully activated!",
        processingError: "Payment processing failed, please contact us",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "Email",
            createdAt: "Created At",
            noRecord: "No Record",
            loginTime: "Last Login",
        },
        orders: {
            title: "Order History",
            loading: "Loading...",
            refresh: "Refresh",
            orderAmount: "Amount",
            points: "Points",
            createdAt: "Created At",
            orderType: "Type",
            status: "Status",
            noOrders: "No Orders",
            goToSubscription: "Buy Points",
            freeCredit: "Free Credit",
            paidCredit: "Paid Credit",
            queryOrderFailed: "Failed to query order",
            statusPaid: "Paid",
            statusPending: "Pending",
            statusCancelled: "Cancelled",
            statusDeactivated: "Deactivated",
            checkoutUrlNotAvailable: "Failed to get checkout URL",
            verifyingPayment: "Verifying payment status...",
            paymentSuccess: "Payment successful",
            paymentPending: "Order is pending payment, please complete payment",
            paymentFailed: "Payment failed or cancelled",
            paymentStatus: "Payment Status",
            paymentStatusDescription: "Have you completed the payment?",
            cancelPayment: "Cancel Payment",
            completedPayment: "Completed Payment",
            warning: "Warning",
            confirmCancelOrder: "Are you sure you want to cancel this order? This action cannot be undone.",
            cancel: "Cancel",
            confirm: "Confirm",
            cancellingOrder: "Cancelling order...",
            orderCancelledSuccess: "Order cancelled",
            cancelOrderFailed: "Failed to cancel order",
            checkOrderStatusFailed: "Failed to check order status",
            promptClick: "Click \"Pending\" status to continue payment",
        }
    },
    Terms: {
        "tabs": {
            "terms": "Terms of Service",
            "privacy": "Privacy Policy",
            "cookies": "Cookie Policy"
        },
        "lastUpdated": "Last updated: May 20, 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Introduction",
                    "description": "Welcome to ClixMagicAI. By using our services, you agree to these Terms of Service. Please read them carefully."
                },
                {
                    "title": "2. Service Description",
                    "description": "ClixMagicAI provides AI-powered tools for removing watermarks from images, videos, and PDFs. Our services are intended for legitimate uses such as:",
                    "items": [
                        "Removing watermarks from your own content",
                        "Removing watermarks from content you have appropriate rights to modify",
                        "Educational and research purposes"
                    ]
                },
                {
                    "title": "3. User Responsibilities",
                    "description": "By using ClixMagicAI, you agree to:",
                    "items": [
                        "Only upload content that you own or have appropriate rights to modify",
                        "Not use our services for any illegal purposes or violate any laws",
                        "Not attempt to circumvent our security measures or usage limitations",
                        "Not use our services to infringe upon others' intellectual property rights"
                    ]
                },
                {
                    "title": "4. Account Terms",
                    "description": "You may need to create an account to use certain features of our service. To log in, you can choose to use your Google or GitHub account. You are responsible for:",
                    "items": [
                        "Maintaining the security of your account",
                        "All activities that occur under your account",
                        "Providing accurate account information (including but not limited to avatar, email, username, and user ID)"
                    ]
                },
                {
                    "title": "5. Free and Paid Services",
                    "description": "ClixMagicAI offers free basic quotas and flexible credit purchase options for accessing our watermark removal features:",
                    "items": [
                        "Basic quota: Each user automatically receives 3 free credits daily for processing content",
                        "Credit consumption rules: Image watermark removal costs 1 credit per use, video watermark removal costs 3 credits per use",
                        "Credit purchase: You can choose to purchase credit packages for more usage, all purchased credits are permanently valid with no expiration",
                        "Refund policy: Due to the immediate and virtual nature of digital services, credits cannot be refunded once purchased"
                    ]
                },
                {
                    "title": "6. Intellectual Property",
                    "description": "The ClixMagicAI service, including all software, designs, and content created by us, is our intellectual property. You may not copy, modify, or create derivative works based on our services without permission."
                },
                {
                    "title": "7. Limitation of Liability",
                    "description": "ClixMagicAI provides services \"as is\" without any warranties. We are not liable for any damages arising from your use of our services."
                },
                {
                    "title": "8. Changes to Terms",
                    "description": "We may modify these terms at any time. Your continued use of ClixMagicAI after such changes indicates your acceptance of the revised terms."
                },
                {
                    "title": "9. Termination",
                    "description": "We reserve the right to immediately terminate or suspend your access to our services without prior notice if we believe your conduct violates these terms or is harmful to other users, us, or third parties."
                },
                {
                    "title": "10. Governing Law",
                    "description": "These terms shall be governed by the laws of our company's place of registration, without regard to its conflict of law provisions."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Introduction",
                    "description": "At ClixMagicAI, we value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and protect your information when you use our website and services. By accessing our website or using any of our services, you accept the data handling practices described in this policy. We comply with applicable data protection regulations."
                },
                {
                    "title": "2. Information We Collect",
                    "description": "We may collect the following types of information:",
                    "items": [
                        { "bold": "Account Information", "text": "User avatar, email address, username, and user ID provided when logging in via Google or GitHub" },
                        { "bold": "Usage Data", "text": "Information about how you use our services, including features accessed and time of use" },
                        { "bold": "Uploaded Content", "text": "Images, videos, or PDFs you upload for processing" },
                        { "bold": "Payment Information", "text": "Payment information when purchasing subscriptions (securely processed by third-party payment gateways like Creem/Stripe/PayPal, we only retain payment status records)" },
                        { "bold": "Technical Data", "text": "IP address, browser type, device information" }
                    ]
                },
                {
                    "title": "3. How We Use Your Information",
                    "description": "We use your information to:",
                    "items": [
                        { "text": "Provide, maintain, and improve our services" },
                        { "text": "Process and complete transactions" },
                        { "text": "Send technical notices and support messages" },
                        { "text": "Respond to your comments and questions" },
                        { "text": "Analyze usage patterns to enhance user experience, processing personal data only to the extent necessary to achieve service objectives" },
                        { "text": "Ensure personal data is not stored longer than necessary" },
                        { "text": "Prevent fraud or illegal activities" }
                    ]
                },
                {
                    "title": "4. Data Security",
                    "description": "We implement industry-standard security measures to protect your personal information:",
                    "items": [
                        { "text": "AES-256 encryption for files in transit and storage" },
                        { "text": "Zero-knowledge architecture for processing sensitive data" },
                        { "text": "Daily security log audits and vulnerability scans" },
                        { "text": "Staff access permissions following the principle of least privilege" }
                    ]
                },
                {
                    "title": "5. Data Sharing",
                    "description": "We do not sell your personal information. We may share information with:",
                    "items": [
                        { "bold": "Service Providers", "text": "Limited to data processing necessary for providing specific services (such as CloudFlare cloud storage, Creem/Stripe/PayPal payment gateways), subject to data processing agreements" },
                        { "bold": "Legal Requirements", "text": "When we receive valid subpoenas, court orders, or other legal processes applicable to us" }
                    ]
                },
                {
                    "title": "6. Your Rights",
                    "description": "Depending on your location and applicable laws, you may have the following rights:",
                    "items": [
                        { "text": "Access a copy of your personal data" },
                        { "text": "Correct inaccurate or incomplete information" },
                        { "text": "Delete data (the 'right to be forgotten'), unless we have legitimate grounds to retain it" },
                        { "text": "Object to or restrict certain types of data processing" },
                        { "text": "Data portability, requesting transfer of your data" }
                    ]
                },
                {
                    "title": "7. Children's Privacy",
                    "description": "Our services are not directed to individuals under 16. According to Article 8 of the General Data Protection Regulation (GDPR), consent for children under 16 must be given by a parent or guardian. If you know that a minor under 16 has provided us with personal information, please contact us immediately at support@clixmagic.com."
                },
                {
                    "title": "8. Changes to This Policy",
                    "description": "We may update this Privacy Policy periodically. We will notify you of any significant changes by posting the new policy on this page and updating the \"last updated\" date. For material changes, we will notify users via email or other prominent means."
                },
                {
                    "title": "9. Contact Us",
                    "description": "If you have any questions about this Privacy Policy, please contact us at support@clixmagic.com. If you believe your data is being improperly handled or have any concerns, please feel free to contact us at any time."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. What Are Cookies",
                    "description": "Cookies are small text files placed on your computer or mobile device when you visit websites. They allow websites to recognize your device and remember if you've visited before."
                },
                {
                    "title": "2. How We Use Cookies",
                    "description": "ClixMagicAI uses cookies for various purposes:",
                    "items": [
                        { "bold": "Essential Cookies", "text": "Required for basic functionality of our website (such as session management and security features)" },
                        { "bold": "Preference Cookies", "text": "Remember your settings and preferences to enhance your experience, such as remembering your avatar, username, etc. after logging in via Google or GitHub" },
                        { "bold": "Analytics Cookies", "text": "Help us understand how visitors interact with our website by collecting anonymous information" },
                        { "bold": "Marketing Cookies", "text": "Track your browsing habits to provide advertisements relevant to your interests" }
                    ]
                },
                {
                    "title": "3. Types of Cookies We Use",
                    "subsection": [
                        {
                            "title": "3.1 Necessary Cookies",
                            "description": "These cookies are essential for the normal functioning of the website. They enable core functions such as security, network management, and account access (including Google and GitHub login). You can set your browser to block these cookies, but some parts of the site may not work properly."
                        },
                        {
                            "title": "3.2 Performance and Analytics Cookies",
                            "description": "These cookies help us understand how visitors interact with our website by collecting anonymous information. We use this data to improve our website and services. These cookies do not collect information that identifies visitors."
                        },
                        {
                            "title": "3.3 Functional Cookies",
                            "description": "These cookies allow our website to remember choices you make (such as language preferences or login status) to provide enhanced personalized features, like remembering your Google or GitHub login status."
                        },
                        {
                            "title": "3.4 Targeting and Advertising Cookies",
                            "description": "These cookies are used to show relevant advertisements to visitors and track the effectiveness of our advertising campaigns. Note that since our website primarily relies on third-party logins (Google and GitHub), these cookies are mainly used to enhance user experience rather than direct marketing."
                        }
                    ]
                },
                {
                    "title": "4. Managing Cookies",
                    "description": "You can control and manage cookies in various ways. Most web browsers allow you to manage cookie preferences. You can:",
                    "items": [
                        { "text": "Delete cookies from your device" },
                        { "text": "Block cookies by activating browser settings that allow you to refuse all or some cookies" },
                        { "text": "Set your browser to notify you when you receive cookies" }
                    ]
                },
                {
                    "title": "5. Third-Party Cookies",
                    "description": "Some cookies are placed by third parties on our website. These third parties may include analytics services (like Google Analytics) and advertising networks. Due to how cookies work (cookies can only be accessed by the party that originally set them), we do not control the use of these third-party cookies and cannot access them. For users logging in via Google and GitHub, we ensure that related information is handled in accordance with these platforms' privacy guidelines."
                },
                {
                    "title": "6. Updates to This Cookie Policy",
                    "description": "We may update this Cookie Policy from time to time to reflect changes in technology, regulations, or our business practices. Any changes will be posted on this page and the revision date updated."
                },
                {
                    "title": "7. Contact Us",
                    "description": "If you have any questions about our use of cookies, please contact us at support@clixmagic.com."
                }
            ]
        }
    },
    Recommend:{
        title: "",
        desc: "",
        collapse: "Collapse",
        expand: "Expand",
        products: [
            {
                "title": "",
                "desc": "",
                "image": "",
                "link": ""
            },
        ]
    },
    UserFeedback: {
        title: "User Testimonials",
        feedback: "Hear genuine reviews of our AI image processing technology from creators and professionals worldwide.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Mr. Lin",
                profession: "Video Editor & Content Creator",
                rating: 5,
                comment: "Amazing! ClixMagicAI processes videos super fast! Upload watermarked videos and get watermark-free versions in minutes with no quality loss. A must-have tool!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Ms. Su",
                profession: "Social Media Specialist",
                rating: 5,
                comment: "ClixMagicAI saved my Instagram content library! It accurately identifies complex watermarks with more natural edge processing than other software I've used."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Mr. Chen",
                profession: "Short Video Producer",
                rating: 5,
                comment: "ClixMagicAI is super convenient! I process TikTok materials during my commute and download high-quality versions at the office. A game-changer for media professionals!"
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Mr. Huang",
                profession: "Graphic Designer & Creative Director",
                rating: 5,
                comment: "As a designer, I'm impressed! When processing client logos, the background texture restoration looks completely natural with no editing traces, saving hours of work."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Ms. Emily",
                profession: "Freelance Digital Content Creator",
                rating: 5,
                comment: "Found a gem! The membership price is cheaper than other watermark removal tools, yet the results are better, especially with gradient transparent watermarks."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Mr. Robertson",
                profession: "Corporate Training Producer",
                rating: 5,
                comment: "ClixMagicAI requires no installation! Perfect when company computers restrict software installations - just use a browser to process materials anytime, anywhere."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Ms. Zhou",
                profession: "Homemaker & Community Editor",
                rating: 5,
                comment: "The interface is so simple even my grandma could use it! Perfect for non-technical users who don't have time to learn professional software like Photoshop. Love it!"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Mr. Johnson",
                profession: "E-commerce Visual Planner",
                rating: 5,
                comment: "ClixMagicAI is incredibly powerful! It can remove watermarks, videos, small objects, bystanders, text, and more. Comprehensive features - highly recommended!"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Ms. Fang",
                profession: "Photography Enthusiast & Content Sharer",
                rating: 5,
                comment: "Wow! Finally found a watermark removal tool that doesn't degrade image quality! Like magic! Photo editing is no longer a challenge! Strongly recommended!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Mr. Williams",
                profession: "Online Education Instructor",
                rating: 5,
                comment: "The watermark position memory feature is super useful! When processing series of course videos, I don't need to reselect areas repeatedly, saving at least 30 minutes of work."
            }
        ]
    },
    Order: {
        purchasePoints: "Purchase Points",
        subtitle: "Choose a suitable points package to enjoy high-quality watermark removal service",
        loginReminderDesc: "Log in to select and purchase points",
        freeTag: "Free",
        freePlan: "Free Plan",
        autoActivated: "Auto-activated after login",
        points: "Points",
        autoIncluded: "Free Gift",
        discount: "Discount",
        purchase: "Buy Now",
        paymentStatusDescription: "Have you completed payment?",
        paymentNotCompleted: "Payment incomplete",
        queryOrderFailed: "Failed to query order status",
        cancelPayment: "Cancel Payment",
        completedPayment: "Payment Completed",
        warning: "Warning",
        confirmCancelOrder: "Are you sure you want to cancel this order? This action cannot be undone.",
        cancel: "Cancel",
        confirm: "Confirm",
        selectProductFirst: "Please select a package first",
        creatingOrder: "Creating order...",
        orderCreated: "Order created successfully",
        createOrderFailed: "Failed to create order",
        checkoutUrlNotAvailable: "Failed to get payment link",
        cancellingOrder: "Cancelling order...",
        orderCancelledSuccess: "Order cancelled",
        cancelOrderFailed: "Failed to cancel order",
        verifyingPayment: "Verifying payment status...",
        paymentSuccess: "Payment successful",
        paymentPending: "Order awaiting payment, please complete payment",
        paymentFailed: "Payment failed or cancelled",
        checkOrderStatusFailed: "Failed to check order status",
        quickStart: "Quick Start",
        shortTerm: "Short-term Use",
        recommended: "Recommended",
        bestValue: "Best Value",
    },
    Login: {
        title: "Login",
        subtitle: "Quick login with social accounts",
        memberTip: "Log in to access more features",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Login with GitHub account"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Login with Google account"
            }
        ],
        error: {
            serverError: "Server error, please try again later",
            networkError: "Network error, please check your connection"
        }
    },
    OAuthCallback: {
        loading: "Processing login request",
        pleaseWait: "Please wait, verifying login information...",
        error: "Login failed",
        backToHome: "Back to Home",
        success: "Login successful",
        redirecting: "Redirecting to homepage..."
    },
    FAQ: {
        title: "ClixMagicAI Guide & FAQ",
        prompt: "Any questions or concerns? Contact us anytime: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "What is ClixMagicAI and how does it work?",
                answer: "ClixMagicAI is an advanced AI-powered watermark removal tool. It automatically identifies watermarks in images and videos and provides manual annotation options. For images, it supports multiple format conversions and ensures high-quality output; for videos, it can process static, dynamic, and shape-changing watermarks."
            },
            {
                id : 2,
                question: "Is ClixMagicAI free to use?",
                answer: "Yes, we offer a basic free service of 3 credits daily! You can use them to process images (1 credit each) or videos (3 credits each). Additionally, you can purchase extra credits that never expire."
            },
            {
                id : 3,
                question: "Can I purchase additional credits?",
                answer: "Absolutely! Besides the 3 free daily credits, you can get extra credits through our purchase options. All purchased credits remain valid permanently with no expiration date."
            },
            {
                id : 4,
                question: "What file formats are supported?",
                answer: "For images, we support PNG, JPEG, JPG, WEBP, HEIC, and HEIF formats, with HEIC and HEIF automatically converted to PNG. For videos, we support multiple formats including MP4 and MOV."
            },
            {
                id : 5,
                question: "How is my privacy protected?",
                answer: "At ClixMagicAI, we highly value user privacy. All uploaded files are encrypted and automatically deleted within 24 hours after processing. We don't store any user files or related information."
            },
            {
                id : 6,
                question: "How can I log in to ClixMagicAI?",
                answer: "We support quick login via GitHub or Google accounts, ensuring your account security while simplifying the registration process."
            },
            {
                id : 7,
                question: "How fast is the processing speed?",
                answer: "Thanks to our high-performance servers and optimized AI algorithms, most image watermark removal tasks complete within 10 seconds, while video watermark removal takes as little as 1 minute. Actual times may vary based on file size and complexity."
            },
            {
                id : 8,
                question: "How good are the results?",
                answer: "Our AI models are extensively trained to intelligently remove watermarks from images and videos while maintaining original content quality. Whether automatically identified or manually annotated watermarks, they can be effectively removed for natural, seamless results."
            },
            {
                id : 9,
                question: "How long are tasks valid?",
                answer: "Once completed, processed files remain available on ClixMagicAI for 24 hours for download. After expiration, files are automatically deleted from our servers to protect your privacy."
            },
            {
                id : 10,
                question: "What are the file size limits?",
                answer: "We accept images up to 10MB and videos up to 100MB. Files exceeding these limits may need compression or cropping before upload."
            }
        ]
    },
    ProductAdv: {
        title: "Explore ClixMagicAI's Powerful Features:",
        advs: [
            {
                title: "AI Smart Recognition Engine: Auto-Detect Various Elements",
                desc: "Based on deep learning algorithms, automatically identifies watermarks, text, faces, and complex background elements in images/videos without manual marking. Supports Instagram, TikTok formats with strict privacy protection.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Remove Watermark"
            },
            {
                title: "Image Purification Master: Remove Logos/Date Stamps, Lossless Quality",
                desc: "Precisely erases brand watermarks, date stamps, stickers, and other distracting elements. AI automatically repairs background textures, making processed images appear natural like the original, perfect for social media posts.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Remove Watermark"
            },
            {
                title: "Dynamic Watermark Eliminator: Remove Scrolling Text/Platform Logos",
                desc: "One-click removal of YouTube end cards, TikTok dynamic watermarks, and scrolling text. AI intelligently tracks and processes frame by frame, outputting smooth 4K HD video in MP4/MOV and other mainstream formats.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Remove Watermark"
            }
        ]
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Pricing",
            faq: "FAQ",
        },
        login: "Login",
        userMenu: {
            account: "Account",
            logout: "Logout",
            credit: "Credits",
            freeCredit: "Free",
            paidCredit: "Purchased",
            nextUpdate: "Next credit update",
            language: "Language",
            theme: "Theme",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    Description:{
        title: "ClixMagicAI",
        desc: "A professional AI-powered watermark removal tool that quickly processes watermarks in images, videos, and PDFs with simple operation and natural results.",
        fileTypes: {
            image: 'Image Watermark Removal',
            pdf: 'PDF Watermark Removal',
            video: 'Video Watermark Removal'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Daily Free Trial", icon: "fa-gift" },
            { id: "imageTag", text: "Image Watermark Removal", icon: "fa-image" },
            { id: "videoTag", text: "Video Watermark Removal", icon: "fa-video" },
            { id: "aiPoweredTag", text: "AI-Powered", icon: "fa-robot" },
            { id: "noRegTag", text: "Login & Use", icon: "fa-user-check" },
        ],
        videoPromt: "Coming soon!",
        videoDesc: "We're developing video watermark removal to bring you an even more powerful experience."
    },
    Footer: {
        social: {
            title: "Contact Us",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Legal Terms",
        terms: [
            {
                id: 1,
                title: "Privacy Policy",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Terms of Service",
                link: "/terms"
            },
            {
                id: 3,
                title: "Cookie Policy",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI All Rights Reserved."
    },
    Task: {
        image: {
            imageSupportText: 'Supports jpg, jpeg, png, webp, heic, heif formats, max 10MB per file',
            imageFileTooLarge: 'File size exceeds limit (max 10MB)',
            invalidImageType: 'Unsupported image format, please upload JPG, JPEG, PNG, WEBP, HEIC or HEIF',
            imageWillCost: 'Will cost: 1 credit',
            hiecSupportText: 'HEIC/HEIF formats will be automatically converted to PNG upon submission',
            hiecSuccess: 'HEIC/HEIF format conversion successful',
            hiecFailed: 'HEIC/HEIF format conversion failed',
            processingImageTip: 'Processing your image, please wait...',
            guide: {
                title: 'User Guide',
                step1: 'Upload image',
                step2: 'Paint over watermark area or let the model auto-detect',
                step3: 'Click Submit'
            }
        },
        common: {
            remaining: 'Remaining credits',
            nextUpdate: 'Next credit update',
            handleError: 'Error processing file, please try another file',
            uploadFailed: 'File upload failed',
            dragText: 'Drag files here or',
            clickText: 'click to upload',
            loginRequired: 'Please log in before uploading files',
            noRemainingTasks: 'You have used all your credits',
            loginNow: 'Login Now',
            upgradeNow: 'Buy Credits Now',
            taskSubmitSuccess: 'Task submitted successfully',
            taskSubmitError: 'Task submission failed',
            taskRetrySuccess: 'Task retry submitted successfully!',
            taskRetryError: 'Task retry submission failed!',
            processing: 'Processing',
            submit: 'Submit',
            waiting: 'Waiting',
            completed: 'Completed',
            failed: 'Failed',
            cancelled: 'Cancelled',
            url_not_found: 'Failed to get link',
            deleted: 'Deleted',
            refreshSuccess: 'Task list refreshed',
            refreshFailed: 'Failed to refresh task list',
            deleteSuccess: 'Task deleted successfully',
            deleteFailed: 'Failed to delete task',
            waitingForCompletion: 'Please wait for current task to complete before retrying',
            loadOriginalImageFailed: 'Failed to load original image, please retry',
            downloadFailed: 'Download failed',
            startingDownload: 'Starting download...',
            noTasks: 'No tasks',
            refresh: 'Refresh',
            sort: 'Sort',
            noFilterTasks: 'No {filter} tasks',
            compare: 'View comparison',
            originalImage: 'Original',
            processedImage: 'Processed',
            dragToCompare: '👈 Drag to compare 👉',
            cancel: "Cancel",
            delete: "Delete",
            retry: "Retry",
            download: "Download",
            createAt: "Created",
            expiredAt: "Expires",
        },
        video: {
            videoSupportText: 'Supports mp4, mov, avi, mkv formats, max 100MB per file',
            videoFileTooLarge: 'File size exceeds limit (max 100MB)',
            invalidVideoType: 'Unsupported video format, please upload MP4, MOV, AVI or MKV',
            videoWillCost: 'Will cost: 3 credits',
            processingVideoTip: 'Processing your video, please wait...',
            guide: {
                step1: 'Upload video',
                step2: 'Select watermark type and define watermark area',
                step3: 'Click Submit'
            },
            annotationTools: 'Watermark Annotation Tools',
            selectType: 'Select watermark type',
            deleteAnnotation: 'Delete annotation',
            clearAllAnnotations: 'Clear all annotations',
            annotationHelp: 'Annotation help',
            dragTip: 'Drag to draw watermark area',
            resizeTip: 'Resize to match watermark',
            moveTip: 'Created annotations can be moved',
            processing: 'Processing',
            submit: 'Submit',
            taskSubmitSuccess: 'Task submitted successfully',
            taskSubmitError: 'Task submission failed',
            retryTaskTip: 'Task retry successful',
            retryFailed: 'Task retry failed',
            uploadFailed: 'Upload failed',
            staticWatermarkDesc: 'For static watermarks in fixed positions',
            normalWatermarkDesc: 'For normal fixed watermarks',
            dynamicWatermarkDesc: 'For changing dynamic watermarks',
            moveWatermarkDesc: 'For watermarks that need to be moved'
        },
    },
    Router: {
        home: "Home",
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        cookie: "Cookie Policy",
        user: "User Center",
    },
}